import { AccessIcon } from '@app/assets/icons/AccessIcon'
import { GuideIcon } from '@app/assets/icons/GuideIcon'
import { PropertyIcon } from '@app/assets/icons/PropertyIcon'
import { RiskIcon } from '@app/assets/icons/RiskIcon'
import { appLink } from '@app/config/appLink'

export const MODULES = [
  {
    id: 'risk',
    title: 'Risk',
    description:
      'Explore climate and hazard risk across your assets and infrastructure. Model scenarios, quantify exposure, and build the evidence base for resilience.',
    actionLabel: 'Open Risk',
    icon: RiskIcon,
    enhanced: false,
    path: appLink.risk.path,
  },
  {
    id: 'property',
    title: 'Property',
    description:
      'Search and assess risk for individual properties: useful for consenting and LIM reporting.',
    actionLabel: 'Learn more',
    icon: PropertyIcon,
    enhanced: true,
    path: appLink.property.path,
  },
  {
    id: 'guide',
    title: 'Guide',
    description:
      'Concepts, methods, case studies, demo videos, and tutorials organised to support risk, resilience and adaptation practice.',
    actionLabel: 'Open Guide',
    icon: GuideIcon,
    enhanced: false,
    path: appLink.guidePage.path,
  },
  {
    id: 'access',
    title: 'Access',
    description:
      'Measure network distance to key amenities (hospitals, schools, emergency services, utilities) to understand community connectivity.',
    actionLabel: 'Open Access',
    icon: AccessIcon,
    enhanced: false,
    path: appLink.access.path,
  },
] as const
